import { FC, lazy, useMemo } from 'react';
import { RouteObject } from 'react-router-dom';

import PublicLayout from '../components/PublicLayout';
import RouteErrorFallback from '../components/RouteErrorFallback/RouteErrorFallback';

const Error404 = lazy<FC>(() => import('../pages/Error404/Error404'));

const Home = lazy<FC>(() => import('../pages/Homepage/Homepage'));

const Crews = lazy<FC>(() => import('../pages/Crews/Crews'));

const Crew = lazy<FC>(() => import('../pages/Crews/Crew/Crew'));

const News = lazy<FC>(() => import('../pages/News/News'));

const SingleNew = lazy<FC>(() => import('../pages/News/SingleNew/SingleNew'));

const About = lazy<FC>(() => import('../pages/Details/About/About'));

const Rating = lazy<FC>(() => import('../pages/Details/Rating/Rating'));

const Contacts = lazy<FC>(() => import('../pages/Contacts/Contacts'));

const Profile = lazy<FC>(() => import('../pages/Profile/Profile'));

const useMyRoutes = () => {
  const publicRoutes = useMemo<RouteObject[]>(
    () => [
      {
        Component: PublicLayout,
        errorElement: <RouteErrorFallback />,
        children: [
          {
            path: '',
            children: [
              {
                Component: Home,
                index: true
              }
            ]
          },

          {
            path: 'crews',
            children: [
              { Component: Crews, index: true },
              {
                path: ':crewId',
                Component: Crew
              }
            ]
          },

          {
            path: 'news',
            children: [
              { Component: News, index: true },
              {
                path: ':singleNewId',
                Component: SingleNew
              }
            ]
          },

          {
            path: 'details',
            children: [
              { Component: About, path: 'about' },
              { Component: Rating, path: 'rating' }
            ]
          },

          { Component: Contacts, path: 'contacts' },

          {
            Component: Error404,
            path: '*'
          }
        ]
      }
    ],
    []
  );

  const privateRoutes = useMemo<RouteObject[]>(() => {
    return [
      {
        Component: Profile,
        path: 'profile'
      }
    ];
  }, []);

  return { privateRoutes, publicRoutes };
};

export default useMyRoutes;
